// @ts-nocheck
import dayjs from 'dayjs';

class DateUtils {
  static now(format) {
    return dayjs().format(format);
  }

  static daysLater(days, format) {
    return dayjs().add(days, 'day').format(format);
  }

  static daysTill(date) {
    return dayjs(date).diff(dayjs(), 'day');
  }

  static hoursTill(date) {
    return dayjs(date).diff(dayjs(), 'hour');
  }

  static minutesTill(date) {
    return dayjs(date).diff(dayjs(), 'minute');
  }

  static format(date, format) {
    if (!date) {
      return '';
    }
    return dayjs(parseBackendDate(date)).format(format);
  }

  static getDate(date) {
    return this.format(parseBackendDate(date), 'DD-MM-YYYY');
  }

  static getDateTime(date) {
    return this.format(parseBackendDate(date), 'DD-MM-YYYY HH:mm:ss');
  }

  static getYear(date) {
    return this.format(parseBackendDate(date), 'YYYY');
  }

  static getFutureDate(days) {
    return dayjs().add(parseBackendDate(days), 'day').format('DD-MM-YYYY');
  }

  static isBeforeToday(date) {
    return dayjs().isAfter(parseBackendDate(date), 'd');
  }

  static isAfterToday(date) {
    return dayjs().isBefore(parseBackendDate(date), 'd');
  }

  static isValid(date) {
    return dayjs(parseBackendDate(date)).isValid();
  }

  static compareDates(date1, date2) {
    return dayjs(parseBackendDate(date1)).diff(parseBackendDate(date2));
  }
}

/**
 * Handle non-standard date format from backend
 * https://docs.oracle.com/javase/8/docs/api/java/time/format/DateTimeFormatter.html#ISO_ZONED_DATE_TIME
 *
 * XXX: Remove when we're confirmed clear of the old backend
 */
function parseBackendDate(date: string) {
  if (date?.includes?.('[')) {
    return date.replace(/(\[.+\])/g, '');
  }

  return date;
}

export default DateUtils;
